exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #FFF; }\n\n.background > .wrapper {\n  position: fixed;\n  top: calc(50% - 30px);\n  left: 50%; }\n\n/*.background > .wrapper > .loading {\n  margin-top: 40px;\n}*/\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0);\n    opacity: 0; }\n  5% {\n    opacity: 1; }\n  100% {\n    transform: scale(1);\n    opacity: 0; } }\n\n.ball-scale-multiple {\n  position: relative;\n  transform: translateY(-30px); }\n\n.ball-scale-multiple > div:nth-child(2) {\n  animation-delay: -0.4s; }\n\n.ball-scale-multiple > div:nth-child(3) {\n  animation-delay: -0.2s; }\n\n.ball-scale-multiple > div {\n  background-color: #2B303B;\n  border-radius: 100%;\n  animation-fill-mode: both;\n  position: absolute;\n  left: -30px;\n  top: 0;\n  opacity: 0;\n  margin: 0;\n  width: 60px;\n  height: 60px;\n  animation: ball-scale-multiple 1s 0s linear infinite; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = main